/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Remove_User_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to remove user. Please try again." |
*
* @param {Members_Remove_User_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_remove_user_error = /** @type {((inputs?: Members_Remove_User_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Remove_User_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Entfernen des Benutzers. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to remove user. Please try again.")
});